<template>
  <div style="padding-top: 50px;">
    <el-row>
      <el-col :span="8" :offset="2">
        <div v-loading="loading" style="height: 700px; overflow: auto;">
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="code"
            :props="defaultProps"
            :default-expanded-keys="expandedKeys"
            :expand-on-click-node="false"
            :accordion="true"
            :load="loadNode"
            lazy
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ node, data }" class="custom-tree-node">
              <span>{{ node.label }}</span>
              <span>
                <el-tooltip
                  v-if="getLimit('authorityCreate_search_button')"
                  class="item"
                  effect="dark"
                  content="新增"
                  placement="top"
                >
                  <vxe-button type="text" @click="() => append(data, node)">
                    <i class="el-icon-circle-plus" />
                  </vxe-button>
                </el-tooltip>
                <el-tooltip
                  :hidden="
                    !getLimit('authorityCreate_delete_button') ||
                      data.level === 0
                  "
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <vxe-button type="text" @click="() => remove(node, data)">
                    <i class="el-icon-error" />
                  </vxe-button>
                </el-tooltip>
              </span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="9" :offset="1">
        <el-form ref="form" :rules="rules" :model="form" label-width="160px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="名称" prop="realName">
                <el-input
                  v-model="form.realName"
                  placeholder="请输入名称"
                  maxlength="100"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="资源名称" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="路由name(首字符大写)"
                  maxlength="100"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="标题" prop="title">
                <el-input
                  v-model="form.title"
                  placeholder="请输入标题"
                  maxlength="100"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="资源权限" prop="permission">
                <el-input
                  v-model="form.permission"
                  placeholder="请输入资源权限"
                  maxlength="200"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="资源url" prop="url">
                <el-input
                  v-model="form.url"
                  placeholder="请输入资源url"
                  maxlength="200"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="资源src" prop="component">
                <el-input
                  v-model="form.component"
                  placeholder="请输入资源src"
                  maxlength="500"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="排序" prop="sort">
                <el-input
                  v-model="form.sort"
                  placeholder="请输入排序"
                  clearable
                  @input="
                    value =>
                      formFormatter.isInteger(value, oldValue, form, 'sort')
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="图标" prop="icon">
                <el-input
                  v-model="form.icon"
                  placeholder="请输入图标"
                  maxlength="100"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="重定向">
                <el-input
                  v-model="form.redirect"
                  placeholder="请输入"
                  maxlength="255"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="隐藏菜单">
                <el-switch v-model="form.hidden" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="缓存">
                <el-switch v-model="form.keepLive" />
                <span>需要配置相关更新</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="所属系统" prop="belong">
                <el-select
                  v-model="form.belong"
                  placeholder="请选择所属系统"
                  clearable
                >
                  <el-option
                    v-for="item in belongList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    clearable
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- code -->
            <el-col :span="24">
              <el-form-item label="code" prop="code">
                <div style="display: flex;">
                  {{ form.code }}
                  <div
                    v-if="form.code"
                    class="menu_text_blue"
                    @click="copyCode('move', form.code)"
                    style="cursor: pointer;color:#2b71ad;margin-right:20px;margin-left:20px;"
                  >
                    移动菜单
                  </div>
                  <div
                    v-if="form.code"
                    class="menu_text_blue"
                    @click="copyCode('target', form.code)"
                    style="cursor: pointer;color:#2b71ad;"
                  >
                    目标菜单
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button
                  v-if="getLimit('authorityCreate_affirm_button')"
                  type="primary"
                  @click="funcSubmit"
                >
                  确 定
                </el-button>
                <el-button
                  v-if="getLimit('authorityCreate_reset_button')"
                  @click="resetForm('form')"
                >
                  重 置
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <div class="code_wrap">
      <p>调整菜单位置</p>
      <div class="menu_box">
        <div class="menu_text">移动菜单code</div>
        <el-input
          :disabled="true"
          v-model="codeObj.sourceCode"
          placeholder="请输入"
        />
      </div>
      <div class="menu_box">
        <div class="menu_text">目标菜单code</div>
        <el-input
          :disabled="true"
          v-model="codeObj.targetCode"
          placeholder="请输入"
        />
      </div>
      <el-button type="primary" @click="submiteCode">提交</el-button>
    </div>
  </div>
</template>
<script>
import { getListDict } from "@/api/commonApi";
import { menuExchangeResult } from "@/api/user";
import {
  addResourceTree,
  updateResourceTree,
  delResourceTree
} from "@/api/authorityCreate";
import request from "@/utils/request";
import { getUUID } from "@/utils/index";
export default {
  name: "AuthorityCreate",
  data() {
    return {
      codeObj: {
        sourceCode: "",
        targetCode: ""
      },
      loading: false,
      emptyForm: {},
      treeData: [],
      mode: "add",
      expandedKeys: ["affcc9e275ab4ef784637299e21c7ef2"],
      defaultProps: {
        label: "realName",
        children: "child"
      },
      belongList: [
        { name: "通用", code: "COMMON" },
        { name: "网络货运", code: "TMS" },
        { name: "同城", code: "CTMS" },
        { name: "仓储", code: "WMS" },
        { name: "园区", code: "PARK" }
      ],
      form: {
        parentCode: "",
        level: "",
        code: "",
        realName: "common",
        name: "",
        title: "",
        permission: "",
        url: "",
        component: "",
        sort: "1",
        icon: "",
        belong: "",
        hidden: false,
        keepLive: false,
        redirect: ""
      },
      rules: {
        realName: [
          { required: true, message: "名称不能为空", trigger: "blur" }
        ],
        name: [
          { required: false, message: "缓存资源不能为空", trigger: "blur" }
        ],
        title: [
          { required: true, message: "标题名称不能为空", trigger: "blur" }
        ],
        permission: [
          { required: true, message: "资源权限不能为空", trigger: "blur" }
        ],
        url: [{ required: false, message: "资源url不能为空", trigger: "blur" }],
        component: [
          { required: false, message: "资源src不能为空", trigger: "blur" }
        ],
        sort: [{ required: true, message: "排序不能为空", trigger: "blur" }],
        icon: [{ required: false, message: "图标不能为空", trigger: "blur" }],
        belong: [
          { required: true, message: "所属系统不能为空", trigger: "blur" }
        ]
      },
      curNode: ""
    };
  },
  created() {
    this.emptyForm = { ...this.form };
    this.getInfo();
  },
  methods: {
    copyCode(type, code) {
      if (type == "move") {
        this.codeObj.sourceCode = code;
      } else {
        this.codeObj.targetCode = code;
      }
    },
    submiteCode() {
      menuExchangeResult(this.codeObj).then(res => {
        if (res.status == 0) {
          this.$message({
            message: "调整成功",
            type: "success"
          });
          //window页面刷新
          window.location.reload();
        }
      });
    },
    getInfo() {
      this.treeData = [];
      this.form = this.emptyForm;
      this.loading = true;
      // getResourceTree()
      request({
        url: `/ntocc-basic-api/resource/getListByLevel`,
        method: "get",
        params: { level: 0 }
      }).then(response => {
        this.treeData = response.data;
        if (this.treeData.length == 1) {
          // 只有一个根节点时自动展开
          this.expandedKeys.push(this.treeData[0].code);
        }
        this.loading = false;
      });
      // 获取数据字典： 所属系统
      getListDict({ types: "resourBelong" }).then(response => {
        this.belongList = response.data.filter(
          item => item.type === "resourBelong"
        )[0]["dictList"];
      });
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve(this.treeData);
      }
      if (node.level > 0) {
        return request({
          url: `/ntocc-basic-api/resource/getListByParentCode`,
          method: "get",
          params: { parentCode: node.key }
        }).then(response => {
          let data = response.data;
          resolve(data);
          this.loading = false;
        });
      }
    },
    handleNodeClick(data, node) {
      this.mode = "update";
      // 对象深拷贝
      this.form = { ...data };
      if (this.form.child) delete this.form.child;
      this.expandedKeys = [];
      this.getNodeCode(node);
      this.curNode = node;
    },
    getNodeCode(node) {
      this.expandedKeys.push(node.key);
      if (node.parent) {
        this.getNodeCode(node.parent);
      }
    },
    append(data, node) {
      setTimeout(() => {
        const newChild = {
          code: "",
          realName: "common",
          name: "",
          ukName: "common",
          belong: "",
          level: data.level + 1,
          parentCode: data.code,
          permission: "",
          sort: "",
          hidden: false,
          url: ""
        };
        this.expandedKeys = [];
        this.getNodeCode(node);
        this.mode = "add";
        this.form = newChild;
      }, 0);
    },
    remove(node, data) {
      setTimeout(() => {
        this.$confirm("确认删除吗？")
          .then(_ => {
            delResourceTree({ codes: data.code }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              // 无需刷新数据
              this.form = this.emptyForm;
              this.$refs.tree.remove(node);
            });
          })
          .catch(_ => {});
      }, 0);
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          if (this.mode === "update") {
            // 修改接口
            updateResourceTree(this.form).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.curNode.data = { ...this.form }; // 修改节点信息
            });
          } else {
            // 新增接口
            this.form.code = getUUID(32);
            addResourceTree(this.form).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              let parentCode = this.form.parentCode;
              let level = this.form.level;
              let sort = this.form.sort;
              // 追加节点
              if (this.curNode.data.children) {
                this.$set(this.curNode.data, "children", []);
              }
              let item = { ...this.form };
              this.$refs.tree.append(item, this.curNode);
              const newChild = {
                code: "",
                realName: "common",
                name: "",
                ukName: "common",
                belong: "",
                level: level,
                parentCode: parentCode,
                permission: "",
                sort: parseInt(sort) + 1,
                hidden: false,
                url: ""
              };
              this.form = newChild;
            });
          }
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.code_wrap {
  width: 390px;
  margin-left: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  p {
    font-weight: 600;
  }
}
.menu_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .menu_text {
    width: 150px;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
